import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { ReactNode, useContext } from "react";

import { ContributionContext } from "../context";

export function Tile({ children }: { children: ReactNode }) {
  const {
    isLoaded,
    imageSrc,
    showImage,
    tileBackgroundColor = "gray.100"
  } = useContext(ContributionContext);

  if (showImage && imageSrc) return <Box px={2}>{children}</Box>;

  if (!isLoaded) return <Skeleton minH={265} />;

  return (
    <Flex
      px={2}
      minH={265}
      height="100%"
      align="center"
      justify="center"
      bg={tileBackgroundColor}
    >
      <Box
        color={
          tileBackgroundColor === "gray.100"
            ? "blackAlpha.900"
            : "whiteAlpha.900"
        }
        textAlign="center"
      >
        {children}
      </Box>
    </Flex>
  );
}
